import React from 'react'

const EmailSent = ({ closeScreen }) => {
    return (
        <div id="email-sent-success-screen">
            <h3>Thanks For Reaching Out</h3>
            <h4>We will get back to you as soon as possible</h4>
            <button id='emsbtn' onClick={closeScreen}>OK</button>

        </div>
    )
}

export default EmailSent